/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\WorldMapBackground.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the geoFirewall module.
----------------------------------------------------------------*/


export function WorldMapBackground() {
    return (
        <>
            {/* Gradient background */}
            <div
                className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
                style={{
                    backgroundImage: `
                        linear-gradient(to bottom right, rgba(15,23,42,0.95), rgba(30,41,59,0.95), rgba(15,23,42,0.95)),
                        radial-gradient(circle at 25% 25%, rgba(16,185,129,0.05) 0%, transparent 50%),
                        radial-gradient(circle at 75% 75%, rgba(239,68,68,0.05) 0%, transparent 50%)
                    `,
                }}
            />

            {/* Subtle grid overlay */}
            <div
                className="absolute inset-0 opacity-[0.03]"
                style={{
                    backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
                    backgroundSize: '50px 50px',
                }}
            />

            {/* jvectormap CSS overrides */}
            <style>{`
                .jvm-tooltip { display: none !important; }
                path.jvm-region { transition: all 0.3s cubic-bezier(0.4,0,0.2,1); filter: drop-shadow(0 1px 2px rgba(0,0,0,0.3)); }
                path.jvm-region:hover { filter: drop-shadow(0 4px 12px rgba(0,0,0,0.4)) brightness(1.1); transform: translateY(-1px); }
                path.jvm-region[fill="#dc2626"] { filter: drop-shadow(0 0 8px rgba(220,38,38,0.5)) drop-shadow(0 2px 4px rgba(0,0,0,0.3)); }
                path.jvm-region[fill="#dc2626"]:hover { filter: drop-shadow(0 0 12px rgba(220,38,38,0.7)) brightness(1.15); }
                path.jvm-region[fill="#22c55e"] { filter: drop-shadow(0 0 4px rgba(34,197,94,0.2)) drop-shadow(0 2px 4px rgba(0,0,0,0.3)); }
                path.jvm-region[fill="#22c55e"]:hover { filter: drop-shadow(0 0 10px rgba(34,197,94,0.5)) brightness(1.15); }
            `}</style>

            {/* Decorative corner gradients */}
            <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-radial from-emerald-500/10 to-transparent pointer-events-none" />
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-radial from-red-500/10 to-transparent pointer-events-none" />
        </>
    );
}
